export default "__VITE_ASSET__256cc283__"